
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/sales",
      function () {
        return require("private-next-pages/next/courses/sales.tsx");
      }
    ]);
  